module.exports = __webpack_public_path__ + "static/img/theme5.bad1489a.png";